export function roundNumber(num, scale) {
  if (!("" + num).includes("e")) {
    return +(Math.round(num + "e+" + scale) + "e-" + scale);
  } else {
    const arr = ("" + num).split("e");
    let sig = "";
    if (+arr[1] + scale > 0) {
      sig = "+";
    }
    return +(
      Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) +
      "e-" +
      scale
    );
  }
}

export function roundCryptoPrice(input = 0, initialRoundSteps = 8) {
  return roundCrypto(input, initialRoundSteps);
}

export function roundQuantity(input = 0, initialRoundSteps = 0) {
  return roundCrypto(input, initialRoundSteps);
}

export function roundCrypto(input = 0, initialRoundSteps = 0) {
  if (input === 0) {
    return 0;
  }

  let roundedNumber;
  let roundSteps = initialRoundSteps;
  let maxSteps = 10;
  do {
    maxSteps--;
    roundSteps += 2;
    roundedNumber = roundNumber(input, roundSteps);
  } while (roundedNumber === 0 && maxSteps > 0);

  return roundedNumber ? roundedNumber : input;
}

export function roundEstimate(input = 0) {
  if (input === 0) {
    return 0;
  }

  let counter = 0;
  let loopWork = true;
  let loopNumber = input;
  do {
    let number = Math.trunc(loopNumber * 10);
    if (number == 0) {
      loopNumber = loopNumber * 10;
      counter++;
      if (counter >= 3) {
        loopWork = false;
      }
    } else {
      loopWork = false;
    }
  } while (loopWork);

  return roundNumber(input, 3 + counter);
}

export function roundMarketFractionalValue(input = 0) {
  if (input === 0) {
    return 0;
  }

  let counter = 0;
  let loopWork = true;
  let loopNumber = input;
  do {
    let number = Math.trunc(loopNumber * 10);
    if (number === 0) {
      loopNumber = loopNumber * 10;
      counter++;
      if (counter >= 4) {
        loopWork = false;
      }
    } else {
      loopWork = false;
    }
  } while (loopWork);

  counter = 4 + counter > 6 ? 6 : counter + 4;

  return roundNumber(input, counter);
}

export function roundOverviewDepositValue(input = 0) {
  if (input === 0) {
    return 0;
  }

  let counter = 0;
  let loopWork = true;
  let loopNumber = input;
  do {
    let number = Math.trunc(loopNumber * 10);
    if (number === 0) {
      loopNumber = loopNumber * 10;
      counter++;
      if (counter >= 4) {
        loopWork = false;
      }
    } else {
      loopWork = false;
    }
  } while (loopWork);

  counter = 4 + counter > 8 ? 8 : counter + 4;

  return parseScientific(roundNumber(input, counter));
}

export function parseScientific(num) {
  if (!/\d+\.?\d*e[+-]*\d+/i.test(num)) {
    return num;
  }

  const numberSign = Math.sign(Number(num));
  num = Math.abs(Number(num)).toString();

  const [coefficient, exponent] = num.toLowerCase().split("e");
  let zeros = Math.abs(Number(exponent));
  const exponentSign = Math.sign(Number(exponent));
  const [integer, decimals] = (coefficient.indexOf(".") != -1 ? coefficient : `${coefficient}.`).split(".");

  if (exponentSign === -1) {
    zeros -= integer.length;
    num =
        zeros < 0
            ? integer.slice(0, zeros) + "." + integer.slice(zeros) + decimals
            : "0." + "0".repeat(zeros) + integer + decimals;
  } else {
    if (decimals) q -= decimals.length;
    num =
        zeros < 0
            ? integer + decimals.slice(0, zeros) + "." + decimals.slice(zeros)
            : integer + decimals + "0".repeat(zeros);
  }

  return numberSign < 0 ? "-" + num : num;
}



// WEBPACK FOOTER //
// ./resources/js/plugins/calculation.js